import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hdi-teaser-container-loader',
  templateUrl: './teaser-container-loader.component.html',
  styleUrls: ['../teaser-container.component.scss'],
  standalone: true,
  imports: [CommonModule, NgxSkeletonLoaderModule],
})
export class TeaserContainerLoaderComponent {}
